module.exports = __webpack_public_path__ + "static/media/overline.c7a50c7e.svg";